import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const SplitConversationModal = React.lazy(
  () => import("./split-conversation.modal"),
);

const SplitConversation: iModalProps<
  typeof SplitConversationModal,
  {
    conversationId: string;
    onSplit?: (newContactId: string) => void;
    initialValues?: {
      firstName?: string;
      lastName?: string;
      primaryMobile?: string;
      primaryEmail?: string;
    };
  }
> = {
  name: "split-conversation",
  component: GenerateModalWithSuspense(SplitConversationModal),
};

export default SplitConversation;
